import React from 'react';
import img from '../utilitylogobanner.png';

export default function Popup() {
    const overlayStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    };

    const popupStyle = {
        width: '90vw',  // Adjusted width for better responsiveness
        maxWidth: '500px', // Set a maximum width
        height: 'max-content',
        textAlign: 'justify',
        color: 'black',
        padding: '1em',
        overflowY: 'auto', // Allow scrolling if content is too long
        backgroundColor: 'white', // Ensure contrast with text
        borderRadius: '10px',
    };

    const imgHeight = {
        height: "25vh",
        maxHeight: '150px', // Set a max height for the image
        objectFit: 'contain', // Ensure the image scales properly
    };

    const closePopup = () => {
        document.querySelector(".remove-Container").style.display = 'none';
    };

    return (
        <div className='m-auto remove-Container' style={overlayStyle}>
            <div className="popup_container container" style={popupStyle}>
                <div className="popupcontaint d-flex justify-content-between mb-2">
                    <h3>Welcome</h3>
                    <button className='btn d-flex justify-content-end' onClick={closePopup}>
                        <i className='bx bx-x fs-1 text-dark'></i>
                    </button>
                </div>
                <hr />
                <img src={img} className='img-fluid rounded mx-auto d-block' alt='Text Utility' style={imgHeight} />
                <hr />
                <p>“Welcome to our text utility! With this tool, you can easily convert text to uppercase or lowercase, count words and letters, estimate reading time, and even remove extra spaces. Preview your changes before copying the modified text. Whether you’re a writer, blogger, or just need to tidy up your content, our utility has you covered!”</p>
                <p>Feel free to use this paragraph in your popup, and customize it as needed! 😊🚀</p>
            </div>
        </div>
    );
}
